export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/contraloriaccion.jpg',
	   "funcion": '¿Qué es una Auditoría Externa y cómo se realiza?  En este episodio de Contraloría en Acción, conoce su función, fundamento y los requisitos para participar en este proceso de revisión.#ContraloríaEnAcción #PrimeroElPueblo',
		"url" : 'https://www.facebook.com/share/v/1Jvo6JdSK5/',
	},
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/fiscalizacion.jpg',
	    "funcion": 'La transparencia y la fiscalización fortalecen la gestión pública.En el marco del 4.º Encuentro Nacional por la Armonización Legislativa y el Fortalecimiento del Sistema de Fiscalización en México. #ElHidalgoQueQueremos',
		"url" : 'https://www.facebook.com/share/v/1T5N1WNYyq',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	    "funcion": 'En 60 segundos te mostramos las actividades de la semana en la #Contraloría #ElHidalgoQueQueremos',
		"url" : 'https://www.facebook.com/share/v/1DArcjNR4i/',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]